import { policies } from '../content/policies';
import { PolicyContent } from '../components/policy-content';
import '../assets/policy.css';

export default function PolicyPage({ policy }: { policy: keyof typeof policies }) {
    const document = policies[policy];
    return <div className="policy-page theme-content">
        <div className="policy-page-inner">
            <article className="policy-article catalogue-content surface-card border-1 surface-border border-round">
                <h1 className="mt-0">{document.title}</h1>
                <PolicyContent policy={policy} />
            </article>
        </div>
    </div>;
}
